<template>
  <div>
    <Breadcrumbs primary="Финансы" secondary="Движение средств"/>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <FinanceMovementReport get-report-url="/finance/getMovementReport" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FinanceMovementReport from "@shared/components/finance/movement-report/movement-report.component"

export default {
  name: "FinanceMovement",
  title: "Движение средств",
  components: {FinanceMovementReport}
}

</script>